export default {
  buttons: {
    save: 'Save',
    back: 'Back',
    next: 'Next',
    finish: 'Finish',
    cancel: 'Cancel',
    confirm: 'Confirm',
    continue: 'Continue',
    completeREgistration: 'Complete Registration',
    submitting: 'Submitting...',
    learnMore: 'Learn more',
    whatAreCoins: 'What are Coins?',
    skip: 'Skip',
    logout: 'Log out',
    more: 'More',
    connect: 'Connect',
    disconnect: 'Disconnect',
    upload: 'Upload',
    restore: 'Restore default settings',
    saveChanges: 'Save changes',
    retry: 'Retry',
    getStarted: 'Get started'
  },
  alerts: {
    fieldsError: 'Please check the highlighted fields below',
    highlightedItemsError: 'Please check the highlighted fields below'
  },
  separators: {
    and: 'and'
  },
  components: {
    countrySelect: {
      placeholderSearch: 'Search for your country',
      popularCountries: 'Popular countries',
      availableForBusiness: 'Available for Business:',
      onlineDisclaimer:
        'Twism works for online businesses in {country}. Local in-store options will be available soon.',
      comingSoonDisclaimer:
        "Twism is working hard to reach everyone! When we have any updates, we'll let you know via email.",
      undatedDisclaimer:
        "Twism is working hard to reach everyone! When we have any updates, we'll let you know via email.",
      hiperlink: 'Not located in {country}? Select a different country',
      notFound: 'No country matches your search'
    },
    countryItem: {
      status: {
        full: 'In-Store & Online',
        beta: 'Coming Soon',
        online_only: 'Online Only',
        coming_soon: 'Coming Soon',
        undated: 'Coming Soon'
      }
    },
    businessProvider: {
      title: 'Complete your business details',
      connectMy: 'Connect my',
      dontUse: "Don't use any of the platforms above?",
      letsUs: 'Let us know what platform you use.',
      orEnterDetails: 'Or enter details',
      enterDetails: 'Enter details',
      manually: 'manually',
      beta: 'BETA',
      providerModalTitle:
        'What is your <span style="text-transform: capitalize;">{provider}</span> URL?',
      providerApiTokenModalTitle: {
        clover: 'Clover Integration'
      },
      providerApiTokenDescription: {
        clover: ` To proceed with this Integration, please
        <a href="https://support.twism.com/hc/en-us/articles/16070139114509-Installing-Twism-to-Clover-POS" target="__blank" class="link">
          follow this step-by-step guide
        </a>
        and insert your Clover Merchant ID and an API Token below.`
      }
    },
    merchantIDTooltip: {
      title: 'Merchant ID (MID)',
      subTitle:
        'A Merchant ID, or abbreviated as MID, is a unique code provided to you by your payment processor. Usually as a merchant, you’ll recieve a MID when you open a merchant account with a bank.',
      topic: 'Where to find your MID?',
      items: [
        'On the invoice from your POS (Point of Sale) supplier',
        'On the Merchant Copy of the transaction receipt',
        'Sometimes on a sticker affixed to the side of your card payments machine',
        'The original approval email when you opened your Merchant Account',
        'On your monthly Merchant Statement'
      ]
    },
    textField: {
      optional: 'Optional'
    },
    searchResult: {
      title: 'Search result for “{text}”'
    },
    selectDropdownField: {
      optional: 'Optional',
      multiselect: {
        placeholder: 'Select an option',
        tagPlaceholder: 'Press enter to create a tag',
        selectLabel: 'Press enter to select',
        selectGroupLabel: 'Press enter to select group',
        selectedLabel: 'Selected',
        deselectLabel: 'Press enter to remove',
        deselectGroupLabel: 'Press enter to deselect group',
        noOptions: 'List is empty.',
        noResult: 'No elements found. Consider changing the search query.'
      },
      multiselectAddress: {
        placeholder: 'Search address',
        tagPlaceholder: 'Press enter to create a address tag',
        selectLabel: 'Press enter to select',
        selectGroupLabel: 'Press enter to select group',
        selectedLabel: 'Selected',
        deselectLabel: 'Press enter to remove',
        deselectGroupLabel: 'Press enter to deselect group',
        noOptions: 'Please enter your address and select it from the list',
        noResult:
          'No address found. Please check for any possible typos and try again.'
      },
      googleAddress: {
        placeholder:
          'e.g. Seaside Cafe, 1234 Ocean Avenue, Santa Barbara, CA 93101',
        tagPlaceholder: 'Press enter to create a address tag',
        selectLabel: 'Press enter to select',
        selectGroupLabel: 'Press enter to select group',
        selectedLabel: 'Selected',
        deselectLabel: 'Press enter to remove',
        deselectGroupLabel: 'Press enter to deselect group',
        noOptions:
          'Please enter your business name and select it from the list',
        noResult:
          'No address found. Please check for any possible typos and try again.'
      },
      searchBar: {
        placeholder: 'What are you looking for?',
        selectLabel: 'Press enter to select',
        emptyState: {
          title: 'No results found',
          description:
            '"{text}" did not match any page.<br/>Try to do a new search.'
        }
      },
      addressField: {
        placeholder: 'Full address',
        tagPlaceholder: 'Press enter to create a address tag',
        selectLabel: 'Press enter to select',
        selectGroupLabel: 'Press enter to select group',
        selectedLabel: 'Selected',
        deselectLabel: 'Press enter to remove',
        deselectGroupLabel: 'Press enter to deselect group',
        noOptions: 'Please enter your address and select it from the list',
        noResult:
          'No address found. Please check for any possible typos and try again.'
      }
    },
    textInputMax: {
      characters: 'characters'
    },
    loyaltyConfigForm: {
      labels: {
        inCoins: 'in Coins',
        customValue: 'custom value',
        or: 'or',
        percent: '%'
      }
    },
    refundConfigForm: {
      labels: {
        day: 'day',
        later: 'later',
        customValue: 'custom value',
        or: 'or',
        noWaiting: 'no waiting',
        instantly: 'Instantly'
      }
    },
    loyaltyExample: {
      title: 'Example:',
      example1: {
        start: 'Lisa spends',
        end: 'at your business',
        altThumb: 'Member example'
      },
      example2: {
        start: 'She will earn',
        end: '{coinsPluralizer}',
        altThumb: 'Business logo'
      },
      example3: {
        start: 'She can pay with her',
        end: '<br /> {coinsPluralizer} on a future purchase.'
      },
      disclaimer:
        '1 Coin = {currencySymbol}1 {currencyName}. Coins cannot be cashed out — only used for purchases.'
    },
    loyaltyExampleV2: {
      title: 'Example:',
      example1: {
        start: 'Lisa buys',
        middle: 'in Coins',
        end: 'at your business',
        altThumb: 'Member example'
      },
      example2: {
        start: 'She will get',
        end: '{coinsPluralizer}',
        altThumb: 'Business logo'
      },
      example3: {
        start: 'She can pay with her',
        end: '<br /> {coinsPluralizer} on a future purchase.'
      },
      disclaimer:
        '1 Coin = {currencySymbol}1 {currencyName}. Coins cannot be cashed out — only used for purchases.'
    },
    widgetConfigForm: {
      title: 'Widget settings',
      labels: {
        color: 'Color:',
        placement: 'Placement',
        placementTooltip:
          'We recommend the Left side option to avoid conflicts with other widgets installed.',
        leftSide: 'Left Side',
        rightSide: 'Right Side',
        horizontally: 'Horizontally',
        unit: 'pixels',
        vertically: 'Vertically',
        recommend: 'We recommend 30px by default.',
        desktopPositioning: 'Desktop Positioning',
        mobilePositioning: 'Mobile Positioning',
        active: 'Active',
        inactive: 'Inactive',
        changeWelcome: 'Display a welcome message',
        changeWelcomeTooltip:
          'When active, your widget will display a welcome message to members upon their first visit'
      }
    },
    widgetConfigFormV2: {
      title: 'Widget settings',
      disabledTooltip:
        'Keep your widget enabled so members can redeem their rewards on your website using their digital wallets.',
      labels: {
        launcher: {
          text: 'Launcher',
          onlyIcon: 'Only icon',
          bothTextIcon: 'Text & icon'
        },
        visibility: {
          text: 'Visibility',
          desktop: 'Desktop',
          mobile: 'Mobile',
          both: 'Both'
        },
        text: 'Text',
        icon: 'Icon',
        color: 'Theme',
        title: 'Title',
        description: 'Description',
        placement: 'Placement',
        status: 'Status',
        placeholderText: 'e.g. Loyalty Rewards',
        placeholderTitle: 'e.g Hey there 👋',
        placeholderDescription:
          "e.g You'll be rewarded with your loyalty Coins after checkout!",
        placementTooltip:
          'We recommend the Left side option to avoid conflicts with other widgets installed.',
        leftSide: 'Left Side',
        rightSide: 'Right Side',
        horizontally: 'Horizontally',
        unit: 'pixels',
        vertically: 'Vertically',
        recommend: 'We recommend 30px by default.',
        desktopPositioning: 'Desktop Positioning',
        mobilePositioning: 'Mobile Positioning',
        active: 'Active',
        inactive: 'Inactive',
        changeWelcome: 'Display a welcome message',
        changeWelcomeTooltip:
          'When active, your widget will display a welcome message to members upon their first visit',
        titleError: 'You need to enter some title',
        descriptionError: 'You need to enter some description',
        modals: {
          discardChanges: {
            title: 'Discard changes',
            description:
              'The latest changes have not yet been saved. If you leave now, they will be lost:',
            disclaimer: 'Are you sure you want to leave?',
            btnPrimary: 'Discard and leave',
            btnSecondary: 'Keep editing'
          },
          restore: {
            title: 'Restore default settings',
            description:
              'This action will undo all your modifications on the widget, returning it to the default version. This action cannot be undone.',
            disclaimer: 'Are you sure you want to reset?',
            btnPrimary: "I'm sure",
            btnSecondary: 'Cancel'
          }
        }
      }
    },
    devicePreviewBox: {
      tabLabel: 'Device Preview:',
      desktopLabel: 'desktop',
      mobileLabel: 'mobile'
    },
    widgetPopover: {
      title: 'Welcome to <br />our reward program!',
      disclaimer: 'Get X% back in Coins for every purchase',
      description:
        "With every purchase you'll earn Coins which can be exchanged for a discount of equal value.",
      joinNow: 'Join now',
      howItWorks: 'How it works',
      powered: 'Powered by © <strong>Twism</strong>'
    },
    widgetPopoverV2: {
      title: 'Earn X% back in <br />Coins on every purchases!',
      joinNow: 'Become a lifelong saver',
      already: 'Already have an account? <span>Sign In</span>',
      titleCarousel: 'Save on every purchase!',
      descriptionCarousel:
        'Our rewards program is <strong>simple and easy!</string> See how it works  👉',
      powered: 'Powered by © <strong>Twism</strong>'
    },
    providerBox: {
      status: {
        connected: {
          label: 'Connected',
          required: 'Required if you use {displayName}'
        },
        available: {
          label: 'Available for <b>{firstType}</b> {secondType}.'
        },
        comingSoon: {
          label: 'Coming Soon'
        }
      },
      contextMenuOption: {
        widget: 'Widget Settings',
        cancelIntegration: 'Cancel Integration'
      },
      types: {
        labels: {
          physical_online: 'Online & Physical',
          physical: 'Physical Stores',
          online: 'Online Stores'
        },
        limitations: {
          only: 'only',
          stores: 'stores'
        }
      }
    },
    widgetEmptyState: {
      title: 'Widget',
      description:
        'The widget is a tool that helps boost engagement and enables members to interact with your Loyalty Program directly from your website.',
      descriptionProviders:
        'Available to businesses using <strong>Wix</strong>, <strong>Shopify</strong>, <strong>BigCommerce</strong> or <strong>WooCommerce</strong>.',
      button: 'Connect my website'
    },
    widgetSettings: {
      title: 'Widget',
      description:
        'Your widget is the small interactive window on your website that allows members to engage with your Loyalty Rewards Program. It enables members to claim, earn, and use their Loyalty Rewards in real-time.'
    },
    imageUpload: {
      textDrag: 'Drop the image here!',
      altImagePreview: 'preview image',
      buttons: {
        editCrop: 'Edit crop',
        uploadNew: 'Upload new',
        uploadMoreImage: 'Upload a new image',
        buttonLabelText: {
          default: 'Choose image file',
          src: 'Select a different file'
        }
      },
      placeholder: {
        smaller: 'Upload image',
        small: 'Choose an image',
        medium: 'Drag and drop to upload',
        large:
          '<b>Click here</b> to upload an image <small>- or -</small> Drag and drop',
        largeMobile: '<b>Click here</b> to upload an image',
        rectangle: 'Drag and drop or browse to choose a file',
        other: 'Drag and drop <small>- or -</small> Click to upload'
      },
      cropTitleDefault: 'Crop Tool',
      disclaimerTextDefault: '- or -',
      warnNotification:
        'Please select a photo in correct form. Just jpg and png'
    },
    imageUploadV2: {
      textDrag: 'Drag and drop',
      textOr: 'or',
      textChooseImg: 'Choose an image',
      textFull: '<span>Click to upload,</span> or drag and drop',
      warnNotification:
        'Please select a photo in correct form. Just jpg, png and svg'
    },
    imageUploadBlock: {
      label: 'Upload your logo or an image',
      edit: 'Edit',
      click:
        '<span class="btn">Click to upload</span> or<br/>drag and drop the image here',
      formatAcceptable: 'File types accepted are JPEG or PNG.',
      helpText:
        'Use a JPEG, PNG or SVG file. Recommended at least 420 x 420 px and max size 5MB.',
      warnFormatFile:
        'Please select a photo in correct format. Just JPEG and PNG.',
      warnMaximumFileSize: 'Maximum file size is 10MB.',
      maximumFileSizeLabel: 'Max size 10MB.',
      cropTitleDefault: 'Adjust your image'
    },
    docUploadBlock: {
      label: 'Upload a spreadsheet',
      edit: 'Edit',
      click: '<span class="btn">Click to upload</span> or drag and drop',
      formatAcceptable: 'File types accepted are XLSX or CSV.',
      helpText: 'Use a xlsx or csv file. Max size 10MB.',
      warnFormatFile:
        'Please select a spreadsheet in correct format. Just XLSX and CSV.',
      warnMaximumFileSize: 'Maximum file size is 10MB.',
      maximumFileSizeLabel: 'Max size 10MB.'
    },
    coinAnatomy: {
      textDefaultCoin: 'Enter the \nname'
    },
    phoneInput: {
      placeholderSearch: 'Search for your country',
      optional: 'Optional',
      title: 'Country Selection'
    },
    statusBadge: {
      inactive: 'Inactive',
      active: 'Active'
    },
    colapsedConfig: {
      unsaved: 'Unsaved changes'
    },
    interactiveCoin: {
      titleCreation: 'Create your branded Coin',
      frontSideCoin: 'Coin Frontside',
      backSideCoin: 'Coin Backside',
      coinNameField: {
        title: 'Coin name',
        placeholder: 'my-coin-name1',
        tagCoin: 'Coin',
        tagMoney: '$'
      },
      alreadyHaveAccount: {
        labelLink: 'Log in',
        description: 'Already have an account?'
      },
      btnNextLabel: 'Next',
      btnSaveLabel: 'Save',
      errorImgUpload: 'Unable to upload images, please try again',
      errorReserveInfos:
        'Unable to reserve currency information, please try again',
      errorNameUnavailable:
        'Coin name unavailable. Please, enter another name and try again.',
      errorGeneral: 'Oops, something went wrong. Please try again.'
    },
    whatIsNewModal: {
      title: 'We have <span>news for you!</span>',
      description:
        'Watch this video for the latest Twism updates and improvements.',
      btn: 'Got it!',
      link: 'I want to know more about it',
      notification:
        "📣 Within the tab “What's new?” you  can review this video and all Twism updates."
    },
    feedback: {
      title: 'How would you rate your experience with Twism?',
      disclaimer:
        'Any feedback you share is confidential and for internal Twism research purposes.',
      btn: 'Submit',
      rating: {
        bad: 'Bad',
        notGood: 'Not so good',
        regular: 'Regular',
        good: 'Good',
        amazing: 'Amazing'
      },
      message: {
        bad: "We are sorry to hear that your experience wasn't great.",
        good: '{name}, we appreciate you sharing this with us.'
      },
      btnPlaceholder: 'What can we do to improve it?',
      success: {
        title: 'Thanks for your feedback!<br/>We love hearing from you.',
        description:
          'Your opinion matters. If you mentioned any issues or concerns in your feedback, a Twism expert will reach out to assist you.',
        btn: 'Done'
      },
      registered_success: {
        title: 'Your feedback has already been submitted.',
        description:
          "You've completed your review, but you can always contact us at <a href='mailto:support@twism.com'>support@twism.com</a> or via our Help Center.",
        btn: 'Contact us'
      },
      wix_success: {
        description:
          'Review us on the Wix App Market with just a few clicks, and help us let the world know about Twism.',
        btn: 'Review on Wix'
      },
      shopify_success: {
        description:
          'Review us on the Shopify App Store with just a few clicks,<br/>and help us let the world know about Twism.',
        btn: 'Review on Shopify'
      },
      bigcommerce_success: {
        description:
          'Review us on the BigCommerce Apps with just a few clicks,<br/>and help us let the world know about Twism.',
        btn: 'Review on BigCommerce'
      },
      woocommerce_success: {
        description:
          'Review us on the WooCommerce Extensions Store with just a few clicks,<br/>and help us let the world know about Twism.',
        btn: 'Review on WooCommerce'
      },
      email_success: {
        description:
          'Your opinion matters. If you mentioned any issues or concerns in your feedback, a Twism expert will reach out to assist you.',
        btn: 'Go to my dashboard'
      },
      notification:
        '⭐️ Share your feedback with us at any time by accessing this menu.'
    },
    feedbackDisconnect: {
      'step-1': {
        title: 'Why are you disconnecting from Twism?',
        titleWidget: 'Why are you deactivating your widget?',
        btn: 'Next'
      },
      'step-2': {
        title: 'Would you like to share more details?',
        btn: 'Submit'
      },
      inputPlaceholder: 'Please, tell us more about it.',
      description:
        'By disconnecting the provider, the widget will be deactivated from your website, but your business account will still exist on Twism platform.',
      disclaimer:
        'Any feedback you share is confidential and for internal Twism research purposes.',
      success: {
        title: 'Thanks for your feedback! We love hearing from you.',
        description:
          'Your opinion matters. If you mentioned any issues or concerns in your feedback, a Twism expert will reach out to assist you.',
        btn: 'Done'
      }
    },
    feedbackDisconnectV2: {
      'step-1': {
        title: 'Why are you choosing to deactivate your widget?',
        btn: 'Next'
      },
      'step-2': {
        title: 'Would you like to share any more details?',
        btn: 'Next'
      },
      'step-3': {
        title: 'You’re about to deactivate your widget',
        disclaimer:
          'Deactivating your widget means it will no longer be visible to members on your website, makes it difficult for members to access their Loyalty Coins and features.',
        btn: 'Confirm'
      },
      back: 'Back',
      inputPlaceholder: 'Please, tell us more about it.',
      disclaimer:
        'Any feedback you share is confidential and for internal Twism research purposes.',
      success: {
        title: 'Your widget has been deactivated!',
        description:
          'You can activate it again on the Apps and Integrations page at any time.',
        btn: 'Done'
      }
    },
    activateFeatureWidget: {
      title: {
        'must-active': 'You must activate the widget to use this feature',
        default: 'You’re about to activate your widget'
      },
      disclaimer:
        'Activating your widget makes it visible to members on your website, giving them access to their Loyalty Coins and other features.',
      btn: 'Confirm',
      success: {
        title: 'Your widget has been activated!',
        btn: 'Done'
      }
    }
  },
  pluralize: {
    coin: 'Coin | Coins',
    campaign: 'campaign | campaigns',
    member: 'member | members',
    user: 'user | users',
    day: 'day | days',
    location: 'location | locations',
    offer: 'Offer | Offers',
    week: 'week | weeks',
    month: 'month | months'
  },
  routeDisclaimers: {
    referralProgramRestriction:
      'The Referral Program is available for widget only. You can enable it in the “Apps & Integrations” tab.',
    freeCoinsRestriction:
      'Welcome Coins campaigns are usable by any business online, and for physical businesses in the US. Enable campaigns by connecting an online provider in "Apps & Integrations".',
    birthdayClubRestriction:
      'The Birthday Club is usable by any physical businesses in the US, but is not yet available to online businesses.',
    sellingCoinsRestriction:
      'Gift <strike>cards</strike> Coins are not available in {country} at the moment, but will be soon.',
    sellCoinsRestriction:
      'Sell Coins are not available in {country} at the moment, but will be soon.',
    sellCoinsWidgetRestriction:
      'The Sell Coins is available only for businesses connected to Wix, Shopify, WooCommerce or BigCommerce. You can enable it in the “Apps & Integrations” tab.',
    loyaltyWidgetRestriction:
      'Rewards Widget are not available in {country} at the moment, but will be soon.',
    discountsAndCuponsRestriction:
      'Discounts & Coupons are not available in {country} at the moment, but will be soon.',
    specialCoinOffersRestriction:
      'Offers are not available in {country} at the moment, but will be soon.',
    customerImportRestriction:
      'Currently available for businesses using Wix only.',
    customerImportRestrictionWixShopifyBigcommerceWoocommerce:
      'Currently available for businesses using Wix, Shopify, Bigcommerce or Woocommerce.',
    socialRewardsRestriction:
      'The Social Rewards is available for widget only. You can enable it in the “Apps & Integrations” tab.',
    activationEmailsRestriction:
      'The E-mail Automation is available for widget only. You can enable it in the “Apps & Integrations” tab.'
  },
  educationPlayer: {
    title: '👋 Hey there! How about a quick video to learn more {sectionName}?',
    exitNotification:
      'In case you change your mind, find the video again right there. 📹',
    dragAndDrop: 'Drag and drop'
  },
  validations: {
    fields: {
      name: {
        required: 'Please enter a name'
      },
      locationName: {
        required: 'Please enter a location name.',
        max: 'Use a short name to differentiate your store locations.'
      },
      fullname: {
        required: 'Please enter a name and a last name'
      },
      firstName: {
        required: 'Please enter a name'
      },
      lastName: {
        required: 'Please enter a last name'
      },
      email: {
        required: 'Please enter an email',
        email: 'Please enter a valid email'
      },
      businessName: {
        required: 'Please add a business name'
      },
      address: {
        required: 'Please add an address'
      },
      additionalAddress: {
        required: 'Please add an additional address'
      },
      phone: {
        required: 'Please add a phone number'
      },
      phone_input: {
        required: 'Please add a phone number'
      },
      password: {
        required: 'Please enter a password',
        min: 'Use {length} or more characters',
        hasLetter: 'The field must contain at least one letter',
        hasNumber: 'The field must contain at least one number'
      },
      country: {
        required_country: 'Please select a country. This cannot be edited later'
      },
      website: {
        required: 'Please enter a URL',
        url: 'Enter a valid URL'
      },
      image: {
        required_image: 'Please choose an image'
      },
      axxess: {
        password: 'At least 8 characters, one letter and one number.'
      },
      color: {
        required: 'Please choose a color'
      },
      coinName: {
        required: 'Please, enter a Coin name',
        min: 'Use at least {length} characters to name your Coin',
        not_just_numbers_coin_name:
          'A name that contains only numbers is not allowed',
        cant_initialize_with_space:
          'You can’t start your Coin name with space.',
        cant_initialize_with_hyphen:
          'You can’t start your Coin name with a hyphen.',
        cant_finish_with_hyphen:
          'You can’t finish your Coin name with a hyphen.',
        helpText: 'Coin names can only use lowercase, hyphen, number (0-9).'
      },
      operationType: {
        required: 'Please choose an operation type'
      },
      shopify: {
        required: 'Please enter a URL',
        url: 'Enter a valid URL'
      },
      wix: {
        required: 'Please enter a URL',
        url: 'Enter a valid URL'
      },
      bigcommerce: {
        required: 'Please enter a URL',
        url: 'Enter a valid URL'
      },
      woocommerce: {
        required: 'Please enter a URL',
        url: 'Enter a valid URL'
      },
      square: {
        required: 'Please enter a URL',
        url: 'Enter a valid URL'
      },
      clover: {
        required: 'Please enter a URL',
        url: 'Enter a valid URL'
      },
      other: {
        required: 'Please, enter the platform name'
      },
      customerInactiveCustomDays: {
        required: 'Please add the number of days',
        integer: 'Please enter an integer',
        min_value: 'Please enter a number greater than zero'
      },
      category: {
        required: 'Please select a category'
      },
      facebook: {
        url: 'Enter a valid Facebook URL'
      },
      instagram: {
        url: 'Enter a valid Instagram URL'
      },
      apiToken: {
        required: 'Please enter the API Token'
      },
      account_clover: {
        required: 'Please enter the Clover Merchant ID'
      },
      locations: {
        required: 'Please select a location'
      },
      promocode: {
        required: 'Please enter a redemption code'
      },
      broadcast: {
        required: 'Please enter a broadcast'
      },
      workspace: {
        required: 'Please select a workspace'
      },
      broadcastData: {
        required: 'Please select a CSV file'
      },
      description: {
        required: 'Please enter a description'
      },
      document: {
        required: 'Please choose a document'
      },
      dealCoins: {
        required: 'This field is required.'
      },
      dealValue: {
        required: 'This field is required.',
        min_value: 'The minimum value is ${min}'
      }
    }
  },
  specialCoin: {
    singular: 'Offer',
    plural: 'Offers'
  },
  signIn: {
    genericErrorMessage:
      'Something went wrong. Please try again or try logging in with Google/Apple.',
    errorCredentials:
      'That email and password combination is incorret. Please try again!'
  }
};
